// EXPERIMENT: sign_form_signer_carousel_colors_experiment — remove with experiment cleanup
import { usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import type { PetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type SignerCarouselColorsExperiment =
	PetitionDetailsPageUserData['experiments']['signFormSignerCarouselColorsExperiment'];

/**
 * Derived from the experiment's variations, so a new arm is a colored scheme by default and fails to compile
 * until it has a palette, instead of silently rendering as control.
 */
export type SignerCarouselColorScheme =
	| 'default'
	| Exclude<SignerCarouselColorsExperiment['variation'], 'control' | 'fake_control'>;

type SignerCarouselColorsExperimentResult = Readonly<{
	experiment: SignerCarouselColorsExperiment;
	/**
	 * Which palette the recent-signers carousel renders. `default` is the production styling, shared by
	 * `control`, `fake_control` and every fallback resolution, so `fake_control` stays a valid A/A arm.
	 */
	colorScheme: SignerCarouselColorScheme;
	/** False for fallback and QA-override sessions — neither is ever treated or exposed. */
	isRealAssignment: boolean;
}>;

export function useSignerCarouselColorsExperiment(): SignerCarouselColorsExperimentResult {
	const {
		data: {
			experiments: { signFormSignerCarouselColorsExperiment: experiment },
		},
	} = usePetitionDetailsPageUserData();

	return {
		experiment,
		colorScheme: resolveColorScheme(experiment),
		isRealAssignment: !experiment.fallback && !experiment.override,
	};
}

function resolveColorScheme(experiment: SignerCarouselColorsExperiment): SignerCarouselColorScheme {
	switch (experiment.variation) {
		case 'control':
		case 'fake_control':
			return 'default';
		default:
			return experiment.variation;
	}
}
